import { useBackNavigation } from "../../../../hooks/layout/use-back-navigation/useBackNavigation";
import { useBackButton } from "../../../hooks/useBackButton";
import { EmptyComponent } from "../../common/EmptyComponent";
import BackIconButton from "../../common/back-icon-button/back-icon-button";

export const headerV2BackButton = "header-v2-back-button";

function HeaderV2BackButton(): JSX.Element {
  const backButton = useBackButton();
  const { performBackNavigation } = useBackNavigation(backButton);

  if (!backButton) {
    return <EmptyComponent />;
  }

  return <BackIconButton id={headerV2BackButton} data-testid={headerV2BackButton} onClick={performBackNavigation} />;
}

export default HeaderV2BackButton;
